'use client';

import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';

function CodeBlock({ className, children }) {
  const language = className?.replace('lang-', '');

  // Handle inline code (no language class)
  if (!className) {
    return (
      <code className="bg-light border p-1 rounded text-warning">
        {children}
      </code>
    );
  }

  // Handle code blocks
  return (
    <SyntaxHighlighter className="mt-0" language={language || 'bash'} style={docco}>
      {children}
    </SyntaxHighlighter>
  );
}

export default CodeBlock;
